import React from 'react';
import { Button, Icon, IconList } from 'components/core';

type Props = {
  fileName: string;
  handleDelete: () => void;
};

const DeleteFileButton = ({ fileName, handleDelete }: Props) => (
  <Button
    iconOnly
    variant="ghost"
    aria-label={`Remove file ${fileName}`}
    onClick={handleDelete}
  >
    <Icon icon={IconList.light.faTrashCan} />
  </Button>
);

export default DeleteFileButton;
